import { Serializable } from '@/models/core/serializable';
import { Competency } from '@/models/competency/competency';

export class CompetencyByType implements Serializable<CompetencyByType> {
  competencyType: number;
  competencies: Competency[];

  deserialize(input: any): CompetencyByType {
    this.competencyType = input.competencyType;
    this.competencies = input.competencies.map((competency: any) => new Competency().deserialize(competency));

    return this;
  }

  get names(): string[] {
    return this.competencies.map((competency: Competency) => competency.name);
  }
}
